import React from "react";
import AdminLayout from "@/components/AdminLayout";
import CmsResource from "@/components/CmsResource";

const fields = [
  { name: "question", label: "Pergunta", type: "text", wide: true },
  { name: "answer", label: "Resposta", type: "textarea", wide: true, rows: 4 },
  { name: "category", label: "Categoria", type: "select", options: ["geral", "comprar", "vender", "avaliacao"] },
  { name: "order", label: "Ordem", type: "number" },
];

const defaults = { question: "", answer: "", category: "geral", order: 0 };

export default function AdminFaqs() {
  return (
    <AdminLayout>
      <CmsResource
        resource="faqs"
        title="FAQs"
        singular="FAQ"
        fields={fields}
        defaults={defaults}
        displayColumns={[
          { key: "question", label: "Pergunta" },
          { key: "category", label: "Categoria" },
          { key: "order", label: "Ordem" },
        ]}
      />
    </AdminLayout>
  );
}
